import { useEffect, useRef, useState } from 'react';
import './Carousel.css';

const Carousel = ({ projectName }) => {
    const [media, setMedia] = useState([]); // unified stills and videos
    const carouselRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const fetchMedia = async () => {
            try {
                const res = await fetch(`${process.env.PUBLIC_URL}/WORK/${projectName}/data.json`);
                const data = await res.json();

                // Combine images and videos into a single array with type tags
                const images = (data.stills || []).map(filename => ({
                    type: 'image',
                    src: `WORK/${projectName}/STILLS/${filename}`
                }));

                const videos = (data.videos || []).map(filename => ({
                    type: 'video',
                    src: `WORK/${projectName}/CLIPS/${filename}`
                }));

                setMedia([...images, ...videos]);
                setCurrentIndex(0);
            } catch (err) {
                console.error("Error loading media:", err);
            }
        };

        fetchMedia();
    }, [projectName]);

    const changeSlide = (direction) => {
        if (!carouselRef.current || media.length === 0) return;

        const newIndex = (currentIndex + direction + media.length) % media.length;
        setCurrentIndex(newIndex);
    };

    return (
        <div className="main-box">
            {media.length === 0 ? (
                <p>Loading media...</p>
            ) : (
                <div className="carousel-container">
                    <div className="carousel">
                        <div className="carousel-inner" ref={carouselRef}>
                            {media.map((item, index) => (
                                <div
                                    className={`carousel-item ${index === currentIndex ? "active" : ""}`}
                                    key={index}
                                >
                                    {item.type === 'image' ? (
                                        <img src={`${process.env.PUBLIC_URL}/${item.src}`} alt={`slide-${index}`} />
                                    ) : (
                                        <video
                                            width="90%"
                                            height="auto"
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            src={`${process.env.PUBLIC_URL}/${item.src}`}
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="carousel-left" onClick={() => changeSlide(-1)}></div>
                        <div className="carousel-right" onClick={() => changeSlide(1)}></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Carousel;
